import request from "@/utils/request";

export default function check(merchantId,params) {
    return request({
        url: `/merchant/agency/check/`+merchantId,
        method: 'post',
        data:params
    })
}
